import React, { useState, useEffect } from 'react';

import Select from '../../../../../../Form/Select';

export default function TypeDropdown({ value, options, updateType, readOnly }) {
  const [currentValue, setCurrentValue] = useState(value);

  // Update the type
  useEffect(() => {
    if (currentValue !== value) {
      updateType(currentValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue, value]);

  return (
    <Select
      value={currentValue}
      options={options}
      fixedPosition
      setFieldValue={(_, val) => setCurrentValue(val)}
      readOnly={readOnly}
    />
  );
}
